export const NotFoundPage = () => (
  <div className="section">
    <div className="not-found-page container is-widescreen">
      <div className="title">Sorry, this page isn't available.</div>
      The link you followed may be broken, or the page may have been removed.
    </div>
  </div>
);
